import apiClient from './apiClient'


const getSocialMediaChannels = (tenant) => {
  return apiClient.get(`/${tenant}/SocialMediaChannel`)
}

const getSocialMediaChannel = (tenant, id) => {
  return apiClient.get(`/${tenant}/SocialMediaChannel/${id}`)
}

const createSocialMediaChannel = (tenant, socialMediaChannel) => {
  return apiClient.post(`/${tenant}/SocialMediaChannel`, socialMediaChannel)
}

const updateSocialMediaChannel = (tenant, id, socialMediaChannel) => {
  return apiClient.put(`/${tenant}/SocialMediaChannel/${id}`, socialMediaChannel)
}

const deleteSocialMediaChannel = (tenant, id) => {
  return apiClient.delete(`/${tenant}/SocialMediaChannel/${id}`)
}


export default {
  getSocialMediaChannels,
  getSocialMediaChannel,
  createSocialMediaChannel,
  updateSocialMediaChannel,
  deleteSocialMediaChannel
}
